var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('item',{attrs:{"item":_vm.column,"value":_vm.val},on:{"on-open":_vm.handleOpen}}),(_vm.isOpen)?_c('pad',{on:{"on-close":_vm.handleClose,"on-save":_vm.handleSave}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }